module.exports = __webpack_public_path__ + "img/map.07dc6ba2.png";